import * as React from "react";
import { Menu as UIMenu, MenuProps } from "@stemscopes/ui";

// UI Menu has trouble with accessibility, if some child equal undefined/false/null
const Menu: React.FC<MenuProps> = ({ children, ...rest }) => (
  <UIMenu {...rest}>
    {
      React.Children.toArray(children as React.ReactElement<any>[]).filter(
        Boolean,
      ) as any
    }
  </UIMenu>
);

export default Menu;
